<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<!--EO4M 종합현황-->
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('EO4M 종합현황') }}</span>
				</div>
				<!-- <sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button> -->
			</div>

			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!--작성중-->
							<th class="col-1">{{ getMessage_('작성중') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn(eo4mInfo.noEo4mApprCnt, 'A')">
								{{ eo4mInfo.noEo4mApprCnt }}
							</td>

							<!-- 반려 -->
							<th class="col-1">{{ getMessage_('반려') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn(eo4mInfo.reg10Cnt, 'A')">{{ eo4mInfo.reg10Cnt }}</td>

							<!--작성-->
							<th class="col-1">{{ getMessage_('작성') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn(eo4mInfo.reg20Cnt, 'G')">{{ eo4mInfo.reg20Cnt }}</td>

							<!--검토-->
							<th class="col-1">{{ getMessage_('검토') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn(eo4mInfo.reg30Cnt, 'R')">{{ eo4mInfo.reg30Cnt }}</td>

							<!--승인-->
							<th class="col-1">{{ getMessage_('승인') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn(eo4mInfo.reg40Cnt, 'O')">{{ eo4mInfo.reg40Cnt }}</td>

							<!--완료-->
							<th class="col-1">{{ getMessage_('완료') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn(eo4mInfo.reg50Cnt, 'O')">{{ eo4mInfo.reg50Cnt }}</td>
						</tr>

						<tr>
							<!--승인결과 불합격-->
							<th class="col-1">{{ getMessage_('승인결과 불합격') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn(eo4mInfo.rsltNgCnt, 'C')">{{ eo4mInfo.rsltNgCnt }}</td>

							<!--승인결과 합격-->
							<th class="col-1">{{ getMessage_('승인결과 합격') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn(eo4mInfo.rsltOkCnt, 'LO')">{{ eo4mInfo.rsltOkCnt }}</td>

							<!--승인필요-->
							<th class="col-1">{{ getMessage_('승인필요') }}</th>
							<td class="col-1">{{ eo4mInfo.isir10Cnt }}</td>

							<!--승인불필요-->
							<th class="col-1">{{ getMessage_('승인불필요') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn(eo4mInfo.isir10Cnt, '')">{{ eo4mInfo.isir20Cnt }}</td>

							<!--전체-->
							<th class="col-1"></th>
							<td class="col-1" style="cursor: pointer"></td>

							<!--전체-->
							<th class="col-1"></th>
							<td class="col-1" style="cursor: pointer"></td>
						</tr>
					</tbody>
				</table>
			</div>

			<!--부품검사 종합현황-->
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('부품검사 종합현황') }}</span>
				</div>
			</div>

			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!-- 작성중 -->
							<th class="col-1">{{ getMessage_('작성중') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoClaimClick(partCkuInfo.ckuReg10Cnt, 'A')">
								{{ partCkuInfo.ckuReg10Cnt }}
							</td>
							<!-- 수량 -->
							<th class="col-1">{{ getMessage_('수량') }}</th>
							<td class="col-5" style="cursor: pointer" @click="onGoClaimClick(partCkuInfo.ckuReg10Cnt, 'A')">
								{{ getMessage_('검사수량') }} : {{ partCkuInfo.ckuReg10CkuCnt }} , {{ getMessage_('불량수량') }} :
								{{ partCkuInfo.ckuReg10BadCnt }} , {{ getMessage_('합격수량') }} :
								{{ partCkuInfo.ckuReg10CkuCnt - partCkuInfo.ckuReg10BadCnt }}
							</td>
							<!-- <th class="col-1">{{ getMessage_('미발행') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoRoClick(partCkuInfo.pprNoCnt, 'C')">
								{{ partCkuInfo.pprNoCnt }}
							</td> -->
						</tr>

						<tr>
							<!-- 반려 -->
							<th class="col-1">{{ getMessage_('반려') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoClaimClick(partCkuInfo.ckuReg30Cnt, 'A')">
								{{ partCkuInfo.ckuReg30Cnt }}
							</td>
							<!-- 수량 -->
							<th class="col-1">{{ getMessage_('수량') }}</th>
							<td class="col-5" style="cursor: pointer" @click="onGoClaimClick(partCkuInfo.ckuReg30Cnt, 'A')">
								{{ getMessage_('검사수량') }} : {{ partCkuInfo.ckuReg30CkuCnt }} , {{ getMessage_('불량수량') }} :
								{{ partCkuInfo.ckuReg30BadCnt }} , {{ getMessage_('합격수량') }} :
								{{ partCkuInfo.ckuReg30CkuCnt - partCkuInfo.ckuReg30BadCnt }}
							</td>
						</tr>

						<tr>
							<!-- 검사완료 -->
							<th class="col-1">{{ getMessage_('검사완료') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoClaimClick(partCkuInfo.ckuReg20Cnt, 'A')">
								{{ partCkuInfo.ckuReg20Cnt }}
							</td>
							<!-- 수량 -->
							<th class="col-1">{{ getMessage_('수량') }}</th>
							<td class="col-5" style="cursor: pointer" @click="onGoClaimClick(partCkuInfo.ckuReg20Cnt, 'A')">
								{{ getMessage_('검사수량') }} : {{ partCkuInfo.ckuReg20CkuCnt }} , {{ getMessage_('불량수량') }} :
								{{ partCkuInfo.ckuReg20BadCnt }} , {{ getMessage_('합격수량') }} :
								{{ partCkuInfo.ckuReg20CkuCnt - partCkuInfo.ckuReg20BadCnt }}
							</td>
						</tr>

						<tr>
							<!-- 검토 -->
							<th class="col-1">{{ getMessage_('검토') }}</th>
							<td class="col-" style="cursor: pointer" @click="onGoClaimClick(partCkuInfo.ckuReg40Cnt, 'A')">
								{{ partCkuInfo.ckuReg40Cnt }}
							</td>
							<!-- 수량 -->
							<th class="col-1">{{ getMessage_('수량') }}</th>
							<td class="col-5" style="cursor: pointer" @click="onGoClaimClick(partCkuInfo.ckuReg40Cnt, 'A')">
								{{ getMessage_('검사수량') }} : {{ partCkuInfo.ckuReg40CkuCnt }} , {{ getMessage_('불량수량') }} :
								{{ partCkuInfo.ckuReg40BadCnt }} , {{ getMessage_('합격수량') }} :
								{{ partCkuInfo.ckuReg40CkuCnt - partCkuInfo.ckuReg40BadCnt }}
							</td>
						</tr>

						<tr>
							<!-- 승인 -->
							<th class="col-1">{{ getMessage_('승인') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoClaimClick(partCkuInfo.ckuReg50Cnt, 'A')">
								{{ partCkuInfo.ckuReg50Cnt }}
							</td>
							<!-- 수량 -->
							<th class="col-1">{{ getMessage_('수량') }}</th>
							<td class="col-5" style="cursor: pointer" @click="onGoClaimClick(partCkuInfo.ckuReg50Cnt, 'A')">
								{{ getMessage_('검사수량') }} : {{ partCkuInfo.ckuReg50CkuCnt }} , {{ getMessage_('불량수량') }} :
								{{ partCkuInfo.ckuReg50BadCnt }} , {{ getMessage_('합격수량') }} :
								{{ partCkuInfo.ckuReg50CkuCnt - partCkuInfo.ckuReg50BadCnt }}
							</td>
						</tr>

						<tr>
							<!--미발행-->
							<th class="col-1">{{ getMessage_('특채') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoRoClick(partCkuInfo.noCrePprNoCnt, 'C')">
								{{ partCkuInfo.noCrePprNoCnt }}
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<!--불량통보서 종합현황-->
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('불량통보서 종합현황') }}</span>
				</div>
			</div>
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<th class="col-1">{{ getMessage_('KD_입력중') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn('', '1ML')">
								{{ pprInfoKd.kdReg00Cnt }}
							</td>
							<th class="col-1">{{ getMessage_('KD_반려') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn('', '3ML')">
								{{ pprInfoKd.kdReg10Cnt }}
							</td>
							<th class="col-1">{{ getMessage_('KD_작성') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn('', '3MG')">
								{{ pprInfoKd.kdReg20Cnt }}
							</td>
							<th class="col-1">{{ getMessage_('KD_검토') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn('', '3MG')">
								{{ pprInfoKd.kdReg30Cnt }}
							</td>
							<th class="col-1">-</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn('', '3MG')">-</td>

							<th class="col-1">{{ getMessage_('KD_승인') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn('', '3MG')">
								{{ pprInfoKd.kdReg40Cnt }}
							</td>

							<th class="col-1">{{ getMessage_('KD_대책완료') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn('', '3MG')">
								{{ pprInfoKd.kdMdvDdCnt }}
							</td>
						</tr>
						<tr>
							<th class="col-1">{{ getMessage_('LP_입력중') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn('', '1ML')">
								{{ pprInfoLp.lpReg00Cnt }}
							</td>
							<th class="col-1">{{ getMessage_('LP_반려') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn('', '3ML')">
								{{ pprInfoLp.lpReg10Cnt }}
							</td>
							<th class="col-1">{{ getMessage_('LP_작성') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn('', '3MG')">
								{{ pprInfoLp.lpReg20Cnt }}
							</td>
							<th class="col-1">{{ getMessage_('LP_검토') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn('', '3MG')">
								{{ pprInfoLp.lpReg30Cnt }}
							</td>
							<th class="col-1">{{ getMessage_('LP_회신') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn('', '3MG')">
								{{ pprInfoLp.lpReg40Cnt }}
							</td>
							<th class="col-1">{{ getMessage_('LP_승인') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn('', '3MG')">
								{{ pprInfoLp.lpReg50Cnt }}
							</td>
							<th class="col-1">{{ getMessage_('LP_대책완료') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn('', '3MG')">
								{{ pprInfoLp.lpMdvDdCnt }}
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<!-- <div style="width: 450px">
				<div class="sf-table">
					<table class="qms-table" style="cursor: pointer">
						<tbody>

						</tbody>
					</table>
				</div>
			</div> -->

			<!-- 출하검사 종합현황 -->
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('출하검사 종합현황') }}</span>
				</div>
			</div>
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<th class="col-1">{{ getMessage_('검사제품 ID수량') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn('', '1ML')">
								{{ fwdInfo.fwdTotCnt }}
							</td>
							<th class="col-1">{{ getMessage_('종합판정 합격') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn('', '3ML')">
								{{ fwdInfo.fwdOkCnt }}
							</td>
							<th class="col-1">{{ getMessage_('종합판정 불합격') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn('', '3MG')">
								{{ fwdInfo.fwdNgCnt }}
							</td>
							<th class="col-1">-</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn('', '3MG')">-</td>
							<th class="col-1">-</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn('', '3MG')">-</td>

							<th class="col-1">-</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn('', '3MG')">-</td>
						</tr>
						<tr>
							<th class="col-1">{{ getMessage_('공정품질 불합격') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn('', '1ML')">
								{{ fwdInfo.ngPowQltyCdCnt }}
							</td>
							<th class="col-1">{{ getMessage_('LOT불합격') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn('', '3ML')">
								{{ fwdInfo.ngPartBloCdCnt }}
							</td>
							<th class="col-1">{{ getMessage_('입고검사(NG)') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn('', '3MG')">
								{{ fwdInfo.ngPartSrgCdCnt }}
							</td>
							<th class="col-1">{{ getMessage_('외관 불합격') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn('', '3MG')">
								{{ fwdInfo.ngApenCkuCdCnt }}
							</td>
							<th class="col-1">{{ getMessage_('체결 불합격') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn('', '3MG')">
								{{ fwdInfo.ngClfcStCdCnt }}
							</td>
							<th class="col-1">{{ getMessage_('배선/배관 불합격') }}</th>
							<td class="col-1" style="cursor: pointer" @click="onGoPwaApcn('', '3MG')">
								{{ fwdInfo.ngCdcnStCdCnt }}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/PqyTotStts/store/helpers';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {},
			data: '',
			date1: '',
			input1: '',
			pprNo: ''
		};
	},
	created() {
		console.clear();
		this.screen = this.screenArray.get(this.scrId);
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		...qmsComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		...qmsMethods,
		onGoPwaApcn(argsCnt, argsState) {
			console.log('클릭했습니다.');
		},
		claimInfo(argsCnt, argsState) {
			console.log('claimInfo 클릭했습니다.');
		},
		onGoonGoRoClickPwaApcn(argsCnt, argsState) {
			console.log('onGoRoClick클릭했습니다.');
		}
	}
};
</script>

<style></style>
